<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTimer_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.09 2.517C7.09 1.68 7.77 1 8.609 1h7.784a1.517 1.517 0 1 1 0 3.034H8.608c-.838 0-1.517-.679-1.517-1.517Zm3.865 3.93C6.998 7.162 4 10.566 4 14.656 4 19.264 7.806 23 12.5 23s8.5-3.736 8.5-8.345c0-4.09-2.998-7.494-6.954-8.207V4.035h-3.091v2.413Zm7.723 4.673L14.46 15.2a1.618 1.618 0 0 1-1.399.431 1.6 1.6 0 0 1-1.043-.65 1.544 1.544 0 0 1-.235-1.307c.116-.43.415-.812.864-1.02L18 10.163c.612-.283 1.162.489.68.956Z"
        clip-rule="evenodd"
    />
</svg>
